import { ca } from '@cian/analytics';

import { EAnalyticsKey } from '../../types/chatHint';
import { TOffer } from '../../types/offer';
import { getCategory } from '../../utils/trackings_helpers';

export const trackHintQuestionClick = (offer: TOffer, questionName: EAnalyticsKey) => {
  const category = getCategory(offer);

  const [dealType, objectType] = category.split('/');

  ca('eventSite', {
    name: 'oldevent',
    category: 'Messages',
    action: 'click_sopr',
    label: 'short_question',
    products: [
      {
        brand: '',
        category,
        cianId: offer.id,
        dealType,
        hiddenBase: false,
        id: offer.id,
        objectType,
        position: 1,
        price: offer.bargainTerms.priceRur,
        published: true,
        // Всегда передаем 1
        quantity: 1,
        variant: [],
        extra: { questionName },
      },
    ],
  });
};
